import React, { lazy, useEffect } from 'react';
import { useDispatch } from 'react-redux';

const Avatar = lazy(() => import('@/pages/Avatar/UseAvatar/UseAvatar'));

const AvatarEmbedWrapper = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {};
  }, [dispatch]);

  return (
    <>
      <Avatar />
    </>
  );
};

export default AvatarEmbedWrapper;
